//borderColor: (theme) => console.log(theme),
const keyNames = {
  //Start actionTypes
  REUSABLE: "REUSABLE",
  // USER_LOGGED_OUT: "USER_LOGGED_OUT",
  token: "token",
  //End actionTypes
  apiErrors: "apiErrors",
  themeMode: "themeMode",
  apiMsg: "apiMsg",
  extra: "extra",
  isLoading: "isLoading",
  toastData: "toastData",
  isAuthenticated: "isAuthenticated",
  //End multiple
  forceLogOut: "forceLogOut",
  userData: "userData",
  verifyOtpData: "verifyOtpData",
  otpData: "otpData",
  registeredUserData: "registeredUserData",
  caseStudyData: "caseStudyData",
  dialogData: "dialogData",
  drawerData: "drawerData",
  galleryData: "galleryData",
};
export default keyNames;
